import { useEffect, useState } from "react";
import { Card, Image } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { CardBody, CardFooter, Col, Row } from "reactstrap";
import { useDispatch } from "react-redux";
import { setLoading } from "../../store/slices/auth";
import { getAiModules } from "./apiController";

const sampleData = [
    {
        "id": "68e8e3fb4dfca03eaed20bcc",
        "usernumber": "473",
        "user_id": "5eec74153d43efda7491b89f",
        "ai_agent_id": "68c3de9a6ca8196ebde0acae",
        "ai_agent_name": "Speech to Text – Normal",
        "number_of_credits": 100,
        "number_of_credits_consumed": 10,
        "pay_pal_id": "",
        "start_date": "2025-07-10T10:46:19.272Z",
        "end_date": "2025-09-30T10:46:19.272Z",
        "project_id": "000000000000000000000000",
        "status": true
    },
    {
        "id": "68e8e3fb4dfca03eaed20bca",
        "usernumber": "473",
        "user_id": "5eec74153d43efda7491b89f",
        "ai_agent_id": "68c3de9a6ca8196ebde0acac",
        "ai_agent_name": "Speech to Text – Dialization",
        "number_of_credits": 100,
        "number_of_credits_consumed": 25,
        "pay_pal_id": "",
        "start_date": "2025-10-01T10:46:19.272Z",
        "end_date": "2026-01-08T10:46:19.272Z",
        "project_id": "000000000000000000000000",
        "status": true
    },
    {
        "id": "68e8e3fb4dfca03eaed20bcb",
        "usernumber": "473",
        "user_id": "5eec74153d43efda7491b89f",
        "ai_agent_id": "68c3de9a6ca8196ebde0acad",
        "ai_agent_name": "Speech to Text – Translate",
        "number_of_credits": 100,
        "number_of_credits_consumed": 60,
        "pay_pal_id": "",
        "start_date": "2025-05-10T10:46:19.272Z",
        "end_date": "2025-09-10T10:46:19.272Z",
        "project_id": "000000000000000000000000",
        "status": true
    },
    {
        "id": "68e8e3fb4dfca03eaed20bc8",
        "usernumber": "473",
        "user_id": "5eec74153d43efda7491b89f",
        "ai_agent_id": "68c3de9a6ca8196ebde0acaa",
        "ai_agent_name": "Ocr",
        "number_of_credits": 100,
        "number_of_credits_consumed": 5,
        "pay_pal_id": "",
        "start_date": "2025-10-10T10:46:19.272Z",
        "end_date": "2026-02-10T10:46:19.272Z",
        "project_id": "000000000000000000000000",
        "status": true
    },
    {
        "id": "68e8e3fb4dfca03eaed20bc7",
        "usernumber": "473",
        "user_id": "5eec74153d43efda7491b89f",
        "ai_agent_id": "68c3de9a6ca8196ebde0aca9",
        "ai_agent_name": "Literature Search",
        "number_of_credits": 100,
        "number_of_credits_consumed": 90,
        "pay_pal_id": "",
        "start_date": "2025-03-01T10:46:19.272Z",
        "end_date": "2025-05-30T10:46:19.272Z",
        "project_id": "000000000000000000000000",
        "status": true
    },
    {
        "id": "68e8e3fb4dfca03eaed20bc9",
        "usernumber": "473",
        "user_id": "5eec74153d43efda7491b89f",
        "ai_agent_id": "68c3de9a6ca8196ebde0acab",
        "ai_agent_name": "Ai Summary",
        "number_of_credits": 100,
        "number_of_credits_consumed": 30,
        "pay_pal_id": "",
        "start_date": "2025-10-05T10:46:19.272Z",
        "end_date": "2026-01-05T10:46:19.272Z",
        "project_id": "000000000000000000000000",
        "status": true
    },
    {
        "id": "68e8e3fb4dfca03eaed20bc6",
        "usernumber": "473",
        "user_id": "5eec74153d43efda7491b89f",
        "ai_agent_id": "68c3de9a6ca8196ebde0aca8",
        "ai_agent_name": "Deep Search",
        "number_of_credits": 100,
        "number_of_credits_consumed": 75,
        "pay_pal_id": "",
        "start_date": "2025-06-01T10:46:19.272Z",
        "end_date": "2025-08-15T10:46:19.272Z",
        "project_id": "000000000000000000000000",
        "status": true
    }
]



export default function AiModule() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [aiModulesList, setAiModulesList] = useState<any[]>([]);

    useEffect(() => {
        fetchAiModules();
    }, []);

    /**
     * Navigate to subscriptions page for selected module
     */
    const viewAiModulePlan = (selectedModule: any) => {
        navigate("/subscriptions", { state: { aiModule: selectedModule } });
    };

    /**
     * Fetch all AI modules for the user
     */
    const fetchAiModules = async () => {
        try {
            dispatch(setLoading(true));
            const response = await getAiModules();
            const modules = response.data || [];

            // Add computed "isEnabled" field based on EndDate
            const updatedModules = modules.map((module: any) => {
                const now = new Date();
                const endDate = module.end_date ? new Date(module.end_date) : null;
                const isEnabled = endDate ? endDate > now : false;

                return {
                    id: module.id,
                    ai_agent_name: module.ai_agent_name,
                    number_of_credits: module.number_of_credits,
                    number_of_credits_consumed: module.number_of_credits_consumed,
                    subscription_type: module.subscription_type,
                    start_date: module.start_date,
                    end_date: module.end_date,
                    isEnabled,
                    thumbnail: "/images/default-module.png", // Hardcoded thumbnail
                };
            });

            setAiModulesList(updatedModules);
        } catch (error: any) {
            console.error("Error fetching AI modules:", error);
        } finally {
            dispatch(setLoading(false));
        }
    };

    return (
        <div className="ai-module-container">
            <div className="head">
                <div className="module-title">AI Modules</div>
            </div>

            <div className="module-list">
                <Row>
                    {aiModulesList.length === 0 ? (
                        <div className="no-modules">No AI Modules Found</div>
                    ) : (
                        aiModulesList.map((item, index) => (
                            <Col lg={4} md={6} key={index}>
                                <Card className="module-card">
                                    <CardBody>
                                        <div className="description">{item.ai_agent_name}</div>
                                        <div className="module-details">
                                            <div className="credits-info">
                                                <strong>{item.number_of_credits_consumed}</strong> / {item.number_of_credits}
                                                <span className="credits-label">credits used</span>
                                            </div>
                                            <div className="date-info">
                                                {item.start_date && (
                                                    <div className="date-item">
                                                        <small>Start: {new Date(item.start_date).toLocaleDateString()}</small>
                                                    </div>
                                                )}
                                                {item.end_date && (
                                                    <div className="date-item">
                                                        <small>End: {new Date(item.end_date).toLocaleDateString()}</small>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </CardBody>

                                    <CardFooter
                                        className={item.isEnabled ? "footer-enabled" : "footer-disabled"}
                                    >
                                        {!item.isEnabled ? (
                                            <div
                                                className="disabled-module"
                                                onClick={() => viewAiModulePlan(item)}
                                            >
                                                Enable Module
                                            </div>
                                        ) : (
                                            <div className="enabled-module">Enabled</div>
                                        )}
                                    </CardFooter>
                                </Card>
                            </Col>
                        ))
                    )}
                </Row>
            </div>
        </div>
    );
}
